export enum DatasetTypeSlugs
{
    COMMON_FILES = "common.files",
    DEFAULT = "common.files",
    COMMON_FASTQ = "common.fastq",
    ILLUMINA_FASTQ = "illumina.fastq.v1.8",
    INSTRUMENT_DIAGNOSTIC = "instrumentdiagnostic",
    ILLUMINA_ISAAC = "illumina.isaac",
    ILLUMINA_ISAAC_V4 = "illumina.isaac.v4",
    ILLUMINA_TUMOR_NORMAL_V2 = "illumina.tumor_normal.v2",
}